import {Component, OnInit, Inject, Input} from '@angular/core';
import { DOCUMENT } from "@angular/common";
import {OptionService} from "../option/option.service";

declare let attachEvent: any;
declare let __twingle_shareUrl: any;

@Component({
    selector: 'share',
    templateUrl: './share.component.html',
    providers: []
})
export class ShareComponent implements OnInit {
    /**
     * Current Step of the Application
     */
    @Input() step: string;

    /**
     * Current type of the project
     */
    @Input() projectType: string = null;

    /**
     * The URL to the App or the page around (in case of iframe)
     * @type {string}
     */
    url = "";

    /**
     * holds the textkey for the teaser
     * @type {string}
     */
    teaserTextkey = "share.teaser";

    /**
     * constructor
     *
     * @param document
     * @param optionService
     */
    constructor(@Inject(DOCUMENT) private document: any,
                private optionService: OptionService) {}

    /**
     * Initialize the component
     */
    public ngOnInit(): void {
        // Special teaser on doi step
        if (this.step === "doi") {
            this.teaserTextkey = "share.teaser.doi";
        }

        // 1. use the current URL
        this.url = this.document.location.href;

        // 2.check if we have a global variable with a shareURL set (i.e. on the DOI page)
        if (typeof __twingle_shareUrl !== "undefined" && __twingle_shareUrl.length > 0) {
            this.url = __twingle_shareUrl;
        }

        const shareUrl = this.optionService.getOption("share_url");

        // 3. check if are inside an iframe and try to get the URL from the sorounding page
        if ((!shareUrl || shareUrl.length === 0) && window.parent && window !== window.parent) {
            // we are inside an iframe, try to get the URL from outside. Do this only if the parent frame is also the top frame

            const that = this;
            const receiveURL: any = function(event: any) {
                if (event.data && event.data.type && event.data.type === "seturl") {
                    that.url = event.data.value;
                }
            };

            // bind message receiver
            if (window.addEventListener) {
                window.addEventListener("message", receiveURL, false);
            }
            else {
                attachEvent("onmessage", receiveURL);
            }

            // request for the URL to the parent frame
            parent.postMessage({
                "type": "geturl",
                "value": null,
                "cid": OptionService.getConatinerId()
            }, "*");
        }

        // 4. Special URL to share from the project options
        if (shareUrl && shareUrl.length > 0) {
            this.url = shareUrl;
        }
    }

    /**
     * Opens the sharing link in a popup
     * @param event
     * @param url
     */
    openPopup(event: any, url: string): void {
        const height = 450,
            width = 550;

        const left  = (window.innerWidth / 2) - (height / 2),
            top   = (window.innerHeight / 2 ) - (width / 2);

        window.open(url, 'twingleSharWindow', 'height=' + height + ',width=' + width + ',top=' + top + ',left=' + left + ',toolbar=0,location=0,menubar=0,directories=0,scrollbars=0');
        event.preventDefault();
    }

    /**
     * Returns an url as encoded string
     * @param {string} url
     * @returns {string}
     */
    getEncodedUrl(url: string): string {
        return encodeURIComponent(url);
    }
}
